

// import React, { useState, useEffect, useRef } from "react";
// // import Tiffins from "../../../../images/products/all items.jpg";
// import { Link } from "react-router-dom";
// import Menuiteams from "./Menuiteams";
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import MenuIcon from "@mui/icons-material/Menu";
// import MenuCartSidebar from "./MenuCartSidebar.jsx";
// import Orders2 from "./Orders2.jsx";

// const Menudatas = () => {
//     const [activeCategory, setActiveCategory] = useState("");
//     const [parentId, setParentId] = useState(null);
//     const [isVegSelected, setIsVegSelected] = useState(false);
//     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
//     const [items, setItems] = useState([]);
//     const [categories, setCategories] = useState([]);
//     const [filteredCategories, setFilteredCategories] = useState([]);
//     const [isHovered, setIsHovered] = useState(false);
//     const [dishes, setDishes] = useState([]);
//     const [posts, setPosts] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//     // Add this to your existing state declarations
//     const [draggedCategory, setDraggedCategory] = useState(null);
//     const [dragOverCategory, setDragOverCategory] = useState(null);

//     const [containerWidth, setContainerWidth] = useState(
//         window.innerWidth > 1320 ? '160px' : window.innerWidth > 1000 ? '160px' : '150px'
//     );
//     // Add these functions after your existing handler functions

//     const handleDragStart = (e, category) => {
//         setDraggedCategory(category);
//         e.dataTransfer.effectAllowed = "move";
//     };

//     const handleDragOver = (e, category) => {
//         e.preventDefault();
//         if (draggedCategory && draggedCategory.dishId !== category.dishId) {
//             setDragOverCategory(category);
//         }
//     };

//     const handleDragEnd = (e) => {
//         setDraggedCategory(null);
//         setDragOverCategory(null);
//     };

//     const handleDrop = (e, targetCategory) => {
//         e.preventDefault();
//         if (!draggedCategory || draggedCategory.dishId === targetCategory.dishId) return;

//         // Reorder the categories
//         const updatedCategories = [...filteredCategories];
//         const draggedIndex = updatedCategories.findIndex(c => c.dishId === draggedCategory.dishId);
//         const targetIndex = updatedCategories.findIndex(c => c.dishId === targetCategory.dishId);

//         // Remove dragged item
//         const [removed] = updatedCategories.splice(draggedIndex, 1);
//         // Insert at target position
//         updatedCategories.splice(targetIndex, 0, removed);

//         setFilteredCategories(updatedCategories);
//         setDragOverCategory(null);
//     };

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth > 1320) {
//                 setContainerWidth('170px');
//             } else if (window.innerWidth > 1000) {
//                 setContainerWidth('150px');
//             } else {
//                 setContainerWidth('150px');
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth <= 768);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Load saved category from localStorage on initial render
//     useEffect(() => {
//         const savedCategory = localStorage.getItem("activeMenuCategory");
//         if (savedCategory) {
//             setActiveCategory(savedCategory);
//         }
//     }, []);

//     // Fetch all data and determine category visibility
//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) {
//             console.warn("⚠️ vendorId or authToken not found in localStorage");
//             return;
//         }

//         showLoader();

//         // Fetch all dish data
//         fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json',
//             }
//         })
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 // Filter categories where parentId is 0 or null
//                 const allCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

//                 // Filter all dishes where parentId is not 0 or null
//                 const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

//                 // Set all data
//                 setItems(data);
//                 setCategories(allCategories);
//                 setDishes(allDishes);

//                 // Calculate visible categories
//                 const visibleCategories = calculateVisibleCategories(allCategories, allDishes);
//                 setFilteredCategories(visibleCategories);

//                 // Check if saved category is still visible
//                 const savedCategory = localStorage.getItem("activeMenuCategory");
//                 let categoryToSet = "Allitems";

//                 if (savedCategory && savedCategory !== "Allitems") {
//                     // Check if saved category exists and is visible
//                     const savedCategoryVisible = visibleCategories.some(
//                         cat => cat.dishName === savedCategory
//                     );

//                     if (savedCategoryVisible) {
//                         // Set to saved category
//                         categoryToSet = savedCategory;
//                         const selectedCategory = allCategories.find(
//                             cat => cat.dishName === savedCategory
//                         );
//                         if (selectedCategory) {
//                             setParentId(selectedCategory.dishId);
//                         }
//                     } else {
//                         // Saved category is not visible, default to Allitems
//                         categoryToSet = "Allitems";
//                         setParentId(null);
//                         // Clear the saved category since it's no longer valid
//                         localStorage.removeItem("activeMenuCategory");
//                     }
//                 } else if (!savedCategory) {
//                     // No saved category, default to Allitems
//                     categoryToSet = "Allitems";
//                     setParentId(null);
//                 }

//                 setActiveCategory(categoryToSet);
//             })
//             .catch((error) => console.error("Error fetching data:", error))
//             .finally(() => {
//                 hideLoader();
//             });
//     }, []);

//     // Function to determine if a category should be visible
//     const calculateVisibleCategories = (categories, dishes) => {
//         return categories.filter(category => {
//             // Check if category itself is hidden
//             if (category.menuStatus === "Disable") {
//                 return false;
//             }

//             // Get ALL dishes under this category (regardless of menuStatus)
//             const allCategoryDishes = dishes.filter(dish =>
//                 dish.parentId === category.dishId
//             );

//             // If no dishes in this category, hide it
//             if (allCategoryDishes.length === 0) {
//                 return false;
//             }

//             // Check if ALL dishes have balance = 0 (regardless of menuStatus)
//             const allDishesHaveZeroBalance = allCategoryDishes.every(dish =>
//                 Number(dish.balanceQuantity || 0) === 0
//             );

//             // If all dishes have zero balance, hide the category
//             if (allDishesHaveZeroBalance) {
//                 return false;
//             }

//             // Category is visible
//             return true;
//         });
//     };

//     // Recalculate visible categories when items or dishes change
//     useEffect(() => {
//         if (categories.length > 0 && dishes.length > 0) {
//             const visibleCategories = calculateVisibleCategories(categories, dishes);
//             setFilteredCategories(visibleCategories);

//             // Check if current active category is still visible
//             if (activeCategory !== "Allitems") {
//                 const currentCategoryVisible = visibleCategories.some(
//                     cat => cat.dishName === activeCategory
//                 );
//                 if (!currentCategoryVisible) {
//                     // Category is no longer visible, switch to Allitems
//                     setActiveCategory("Allitems");
//                     setParentId(null);
//                     localStorage.setItem("activeMenuCategory", "Allitems");
//                 }
//             }
//         }
//     }, [categories, dishes]);

//     const handleClick = (categoryName) => {
//         if (categoryName === 'Allitems') {
//             setParentId(null);
//             setActiveCategory('Allitems');
//             // Save to localStorage
//             localStorage.setItem("activeMenuCategory", "Allitems");
//             return;
//         }

//         const selectedCategory = categories.find(
//             category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
//         );

//         if (selectedCategory) {
//             setParentId(selectedCategory.dishId);
//             setActiveCategory(categoryName);
//             // Save to localStorage
//             localStorage.setItem("activeMenuCategory", categoryName);
//         } else {
//             setParentId(null);
//             setActiveCategory('Allitems');
//             localStorage.setItem("activeMenuCategory", "Allitems");
//         }
//     };

//     const navigate = useNavigate();

//     // Fetch combos data (unchanged)
//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");
//         if (!vendorId) return;

//         showLoader();
//         axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
//             .then((response) => {
//                 const allDishes = response.data;
//                 const combos = allDishes.filter(dish => dish.dishName === "Combos");
//                 const filteredData = allDishes.filter(dish =>
//                     combos.some(combo => combo.dishId === dish.parentId)
//                 );
//                 setPosts(filteredData);
//             })
//             .catch((error) => {
//                 console.error("Error fetching data:", error);
//             })
//             .finally(() => {
//                 hideLoader();
//             });
//     }, []);

//     return (
//         <>
//             <div className="container-fluid">
//                 <div className="row" style={{ marginTop: "38px" }}>
//                     <div className="col-lg-7 col-md-8 col-sm-12 col-12  maincontent"
//                         style={{ marginTop: window.innerWidth > 500 && window.innerWidth <= 768 ? "-90px" : "20px" }}>

//                         {/* Breadcrumb (unchanged) */}
//                         <p className="breadcrumb maamaas-home-bredcum" style={{
//                             position: "fixed",
//                             top: window.innerWidth <= 430 ? "50px" : window.innerWidth > 430 && window.innerWidth <= 768 ? "60px" : "64px" ,                            
//                             left: "2vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             zIndex: window.innerWidth <= 998 ? 1000 : 100000,
//                             padding: "10px 0",
//                             fontSize: isMobile ? "14px" : "18px",
//                             fontWeight: isMobile ? "normal" : "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}>
//                             <Link to="/fooddashboard" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
//                                 Food & Beverages
//                             </Link>
//                             <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
//                             <Link to="#" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
//                                 Services & Products
//                             </Link>
//                             <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
//                             <Link to="#" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
//                                 Menu
//                             </Link>
//                         </p>

//                         <div className="row anotherrow">
//                             {/* Categories Sidebar */}
//                             <div className={`${isMobile ? 'col-12' : window.innerWidth > 1500 ? 'col-lg-2' : 'col-lg-3 col-md-3'} col-sm-12 col-12`}
//                                 style={{
//                                     marginTop: window.innerWidth <= 767 ? "25px" : "0px",
//                                     marginBottom: isMobile ? "20px" : "0px"
//                                 }}>
//                                 <div style={{
//                                     maxHeight: "600px",
//                                     position: isMobile ? " " : "sticky",
//                                     top: isMobile ? "0px" : "100px",
//                                     marginTop: isMobile ? "0px" : "67px",
//                                     zIndex: 1000,
//                                     scrollbarWidth: "none",
//                                     msOverflowStyle: "none",
//                                 }} className="menu-side-scroll">
//                                     {isMobile ? (
//                                         <select
//                                             onChange={(e) => handleClick(e.target.value)}
//                                             value={activeCategory}
//                                             style={{
//                                                 width: "100%",
//                                                 padding: "12px",
//                                                 borderRadius: "10px",
//                                                 background: "rgb(177 93 198)",
//                                                 color: "#fff",
//                                                 fontWeight: "bold",
//                                                 border: "1px solid #ccc",
//                                                 marginBottom: "0px",
//                                                 fontSize: "16px"
//                                             }}
//                                         >
//                                             <option value="Allitems">All Items</option>
//                                             {filteredCategories.map((category) => (
//                                                 <option key={category.dishId} value={category.dishName}>
//                                                     {category.dishName}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     ) : (
//                                         <div style={{
//                                             overflowY: "auto",
//                                             height: window.innerHeight <= 700 ? "70vh" : "75vh",
//                                             marginTop: "72px",
//                                             scrollbarWidth: "none",
//                                             width: "100%",
//                                             maxWidth: "150px"
//                                         }}>
//                                             {/* "Allitems" Category Card */}
//                                             <div
//                                                 className="card"
//                                                 onClick={() => handleClick("Allitems")}
//                                                 style={{
//                                                     backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
//                                                     marginTop: "4px",
//                                                     padding: "0px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     flexDirection: "column",
//                                                     cursor: "pointer",
//                                                     zIndex: "1",
//                                                     width: "100%"
//                                                 }}
//                                             >
//                                                 {/* <img
//                                                     src={Tiffins}
//                                                     className="card-img-top"
//                                                     alt="Allitems"
//                                                     style={{
//                                                         borderRadius: "50%",
//                                                         width: "80px",
//                                                         height: "80px",
//                                                         display: "block",
//                                                         margin: "5px auto 0",
//                                                     }}
//                                                 /> */}
//                                                 <div className="card-body d-flex justify-content-center p-0">
//                                                     <button style={{
//                                                         borderRadius: "10px",
//                                                         marginTop: "5px",
//                                                         fontSize: "14px",
//                                                         padding: "5px 10px",
//                                                         width: "100px",
//                                                         marginBottom: "5px",
//                                                         background: "#fff",
//                                                         color: "#000",
//                                                         fontWeight: "bold",
//                                                         border: "0px",
//                                                     }}>
//                                                         All
//                                                     </button>
//                                                 </div>
//                                             </div>

//                                             {/* Dynamic Categories - Only show visible ones */}
//                                             {filteredCategories.map((category) => (
//                                                 <div
//                                                     key={category.dishId}
//                                                     className="card"
//                                                     onClick={() => handleClick(category.dishName)}
//                                                     draggable="true"
//                                                     onDragStart={(e) => handleDragStart(e, category)}
//                                                     onDragOver={(e) => handleDragOver(e, category)}
//                                                     onDragEnd={handleDragEnd}
//                                                     onDrop={(e) => handleDrop(e, category)}
//                                                     style={{
//                                                         backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
//                                                         marginTop: "10px",
//                                                         padding: "0px",
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         flexDirection: "column",
//                                                         cursor: "grab",
//                                                         height: "auto",
//                                                         // minHeight: "140px",
//                                                         // width: "100%",
//                                                         // Visual feedback for drag operations
//                                                         opacity: draggedCategory && draggedCategory.dishId === category.dishId ? 0.5 : 1,
//                                                         border: dragOverCategory && dragOverCategory.dishId === category.dishId ?
//                                                             "2px dashed #000" : "none",
//                                                         transform: dragOverCategory && dragOverCategory.dishId === category.dishId ?
//                                                             "scale(1.02)" : "scale(1)",
//                                                         transition: "all 0.2s ease"
//                                                     }}
//                                                 >
//                                                     {/* <img
//                                                         className="card-img-top"
//                                                         src={category.dishImage}
//                                                         alt={category.dishName}
//                                                         style={{
//                                                             borderRadius: "50%",
//                                                             width: "80px",
//                                                             height: "80px",
//                                                             display: "block",
//                                                             margin: "5px auto 0",
//                                                             background: "#000",
//                                                             color: "#fff",
//                                                             objectFit: "cover",
//                                                             // Prevent image drag
//                                                             userSelect: "none",
//                                                             WebkitUserDrag: "none"
//                                                         }}
//                                                     /> */}
//                                                     <div className="card-body d-flex justify-content-center p-0">
//                                                         <button style={{
//                                                             borderRadius: "10px",
//                                                             marginTop: "8px",
//                                                             fontSize: "16px",
//                                                             padding: "5px 8px",
//                                                             background: "#fff",
//                                                             color: "#000",
//                                                             width: "100px",
//                                                             marginBottom: "5px",
//                                                             fontWeight: "bold",
//                                                             border: "0px",
//                                                             whiteSpace: "nowrap",
//                                                             overflow: "hidden",
//                                                             textOverflow: "ellipsis",
//                                                             cursor: "pointer"
//                                                         }}>
//                                                             {category.dishName}
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Menu Items */}
//                             <div className={`${isMobile ? 'col-12' : window.innerWidth > 1500 ? 'col-lg-10' : 'col-lg-9 col-md-9'} col-sm-12 col-12`}>
//                                 <Menuiteams parentId={parentId} />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Cart Sidebar */}
//                     <div className={`${isMobile ? 'col-12' : 'col-lg-3 col-md-4'} col-sm-12 col-12`}
//                         style={{ position: "fixed", right: "10px", display: window.innerWidth <= 768 ? "none" : "block" }}>
//                         <MenuCartSidebar />
//                     </div>
//                 </div>
//             </div>
//             <style>
//                 {`
//     @media (min-width: 1000px) and (max-width: 1050px) {
//         .maincontent {
//             position: fixed;
//             left: calc(100% - 83%);
//         }
//     }

//     @media (min-width: 1051px) and (max-width: 1100px) {
//         .maincontent {
//             position: fixed;
//             left: calc(100% - 84%);
//         }
//     }

//     @media (min-width: 1101px) and (max-width: 1273px) {
//         .maincontent {
//             position: fixed;
//             left: calc(100% - 85%);
//         }
//     }
        
//     @media (min-width: 1274px) {
//         .maincontent {
//             position: fixed;
//             left: calc(100% - 86%);
//         }
//     }
//         @media(max-width:768px) {
//         .anotherrow{
//         margin-top:10px !important;
//         }
//         }
// `}
//             </style>
//         </>
//     );
// };

// export default Menudatas;






import React, { useState, useEffect, useRef } from "react";
// import Tiffins from "../../../../images/products/all items.jpg";
import { Link } from "react-router-dom";
import Menuiteams from "./Menuiteams";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import MenuIcon from "@mui/icons-material/Menu";
import MenuCartSidebar from "./MenuCartSidebar.jsx";
import Orders2 from "./Orders2.jsx";

const Menudatas = () => {
    const [activeCategory, setActiveCategory] = useState("");
    const [parentId, setParentId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);
    const [posts, setPosts] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    // Add this to your existing state declarations
    const [draggedCategory, setDraggedCategory] = useState(null);
    const [dragOverCategory, setDragOverCategory] = useState(null);

    const [containerWidth, setContainerWidth] = useState(
        window.innerWidth > 1320 ? '160px' : window.innerWidth > 1000 ? '160px' : '150px'
    );
    // Add these functions after your existing handler functions

    const handleDragStart = (e, category) => {
        setDraggedCategory(category);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e, category) => {
        e.preventDefault();
        if (draggedCategory && draggedCategory.dishId !== category.dishId) {
            setDragOverCategory(category);
        }
    };

    const handleDragEnd = (e) => {
        setDraggedCategory(null);
        setDragOverCategory(null);
    };

    const handleDrop = (e, targetCategory) => {
        e.preventDefault();
        if (!draggedCategory || draggedCategory.dishId === targetCategory.dishId) return;

        // Reorder the categories
        const updatedCategories = [...filteredCategories];
        const draggedIndex = updatedCategories.findIndex(c => c.dishId === draggedCategory.dishId);
        const targetIndex = updatedCategories.findIndex(c => c.dishId === targetCategory.dishId);

        // Remove dragged item
        const [removed] = updatedCategories.splice(draggedIndex, 1);
        // Insert at target position
        updatedCategories.splice(targetIndex, 0, removed);

        setFilteredCategories(updatedCategories);
        setDragOverCategory(null);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1320) {
                setContainerWidth('170px');
            } else if (window.innerWidth > 1000) {
                setContainerWidth('150px');
            } else {
                setContainerWidth('150px');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Load saved category from localStorage on initial render
    useEffect(() => {
        const savedCategory = localStorage.getItem("activeMenuCategory");
        if (savedCategory) {
            setActiveCategory(savedCategory);
        }
    }, []);

    // Fetch all data and determine category visibility
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            console.warn("⚠️ vendorId or authToken not found in localStorage");
            return;
        }

        showLoader();

        // Fetch all dish data
        fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                // Filter categories where parentId is 0 or null
                const allCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

                // Filter all dishes where parentId is not 0 or null
                const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

                // Set all data
                setItems(data);
                setCategories(allCategories);
                setDishes(allDishes);

                // Calculate visible categories
                const visibleCategories = calculateVisibleCategories(allCategories, allDishes);
                setFilteredCategories(visibleCategories);

                // Check if saved category is still visible
                const savedCategory = localStorage.getItem("activeMenuCategory");
                let categoryToSet = "Allitems";

                if (savedCategory && savedCategory !== "Allitems") {
                    // Check if saved category exists and is visible
                    const savedCategoryVisible = visibleCategories.some(
                        cat => cat.dishName === savedCategory
                    );

                    if (savedCategoryVisible) {
                        // Set to saved category
                        categoryToSet = savedCategory;
                        const selectedCategory = allCategories.find(
                            cat => cat.dishName === savedCategory
                        );
                        if (selectedCategory) {
                            setParentId(selectedCategory.dishId);
                        }
                    } else {
                        // Saved category is not visible, default to Allitems
                        categoryToSet = "Allitems";
                        setParentId(null);
                        // Clear the saved category since it's no longer valid
                        localStorage.removeItem("activeMenuCategory");
                    }
                } else if (!savedCategory) {
                    // No saved category, default to Allitems
                    categoryToSet = "Allitems";
                    setParentId(null);
                }

                setActiveCategory(categoryToSet);
            })
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => {
                hideLoader();
            });
    }, []);

    // Function to determine if a category should be visible
    const calculateVisibleCategories = (categories, dishes) => {
        return categories.filter(category => {
            // Check if category itself is hidden
            if (category.menuStatus === "Disable") {
                return false;
            }

            // Get ALL dishes under this category (regardless of menuStatus)
            const allCategoryDishes = dishes.filter(dish =>
                dish.parentId === category.dishId
            );

            // If no dishes in this category, hide it
            if (allCategoryDishes.length === 0) {
                return false;
            }

            // Check if ALL dishes have balance = 0 (regardless of menuStatus)
            const allDishesHaveZeroBalance = allCategoryDishes.every(dish =>
                Number(dish.balanceQuantity || 0) === 0
            );

            // If all dishes have zero balance, hide the category
            if (allDishesHaveZeroBalance) {
                return false;
            }

            // Category is visible
            return true;
        });
    };

    // Recalculate visible categories when items or dishes change
    useEffect(() => {
        if (categories.length > 0 && dishes.length > 0) {
            const visibleCategories = calculateVisibleCategories(categories, dishes);
            setFilteredCategories(visibleCategories);

            // Check if current active category is still visible
            if (activeCategory !== "Allitems") {
                const currentCategoryVisible = visibleCategories.some(
                    cat => cat.dishName === activeCategory
                );
                if (!currentCategoryVisible) {
                    // Category is no longer visible, switch to Allitems
                    setActiveCategory("Allitems");
                    setParentId(null);
                    localStorage.setItem("activeMenuCategory", "Allitems");
                }
            }
        }
    }, [categories, dishes]);

    const handleClick = (categoryName) => {
        if (categoryName === 'Allitems') {
            setParentId(null);
            setActiveCategory('Allitems');
            // Save to localStorage
            localStorage.setItem("activeMenuCategory", "Allitems");
            return;
        }

        const selectedCategory = categories.find(
            category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
        );

        if (selectedCategory) {
            setParentId(selectedCategory.dishId);
            setActiveCategory(categoryName);
            // Save to localStorage
            localStorage.setItem("activeMenuCategory", categoryName);
        } else {
            setParentId(null);
            setActiveCategory('Allitems');
            localStorage.setItem("activeMenuCategory", "Allitems");
        }
    };

    const navigate = useNavigate();

    // Fetch combos data (unchanged)
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        showLoader();
        axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
            .then((response) => {
                const allDishes = response.data;
                const combos = allDishes.filter(dish => dish.dishName === "Combos");
                const filteredData = allDishes.filter(dish =>
                    combos.some(combo => combo.dishId === dish.parentId)
                );
                setPosts(filteredData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                hideLoader();
            });
    }, []);

    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "38px" }}>
                    <div className="col-lg-7 col-md-8 col-sm-12 col-12  maincontent"
                        style={{ marginTop: window.innerWidth > 500 && window.innerWidth <= 768 ? "-90px" : "20px" }}>

                        {/* Breadcrumb (unchanged) */}
                        <p className="breadcrumb maamaas-home-bredcum" style={{
                            position: "fixed",
                            top: window.innerWidth <= 430 ? "50px" : window.innerWidth > 430 && window.innerWidth <= 768 ? "60px" : "64px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: window.innerWidth <= 998 ? 1000 : 100000,
                            padding: "10px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}>
                            <Link to="/fooddashboard" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                                Food & Beverages
                            </Link>
                            <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
                            <Link to="#" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                                Services & Products
                            </Link>
                            <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
                            <Link to="#" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                                Menu
                            </Link>
                        </p>

                        <div className="row anotherrow">
                            {/* Categories Sidebar */}
                            <div className={`${isMobile ? 'col-12' : window.innerWidth > 1500 ? 'col-lg-2' : 'col-lg-3 col-md-3'} col-sm-12 col-12`}
                                style={{
                                    marginTop: window.innerWidth <= 767 ? "25px" : "0px",
                                    marginBottom: isMobile ? "20px" : "0px"
                                }}>
                                <div style={{
                                    maxHeight: "600px",
                                    position: isMobile ? " " : "sticky",
                                    top: isMobile ? "0px" : "100px",
                                    marginTop: isMobile ? "0px" : "67px",
                                    zIndex: 1000,
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                }} className="menu-side-scroll">
                                    {isMobile ? (
                                        <select
                                            onChange={(e) => handleClick(e.target.value)}
                                            value={activeCategory}
                                            style={{
                                                width: "100%",
                                                padding: "12px",
                                                borderRadius: "10px",
                                                background: "rgb(177 93 198)",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                border: "1px solid #ccc",
                                                marginBottom: "0px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            <option value="Allitems">All Items</option>
                                            {filteredCategories.map((category) => (
                                                <option key={category.dishId} value={category.dishName}>
                                                    {category.dishName}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <div style={{
                                            overflowY: "auto",
                                            height: window.innerHeight <= 700 ? "70vh" : "75vh",
                                            marginTop: "72px",
                                            scrollbarWidth: "none",
                                            width: "100%",
                                            maxWidth: "150px"
                                        }}>
                                            {/* "Allitems" Category Card */}
                                            <div
                                                className="card"
                                                onClick={() => handleClick("Allitems")}
                                                style={{
                                                    backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
                                                    marginTop: "4px",
                                                    padding: "0px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    cursor: "pointer",
                                                    zIndex: "1",
                                                    width: "100%"
                                                }}
                                            >
                                                {/* <img
                                                    src={Tiffins}
                                                    className="card-img-top"
                                                    alt="Allitems"
                                                    style={{
                                                        borderRadius: "50%",
                                                        width: "80px",
                                                        height: "80px",
                                                        display: "block",
                                                        margin: "5px auto 0",
                                                    }}
                                                /> */}
                                                <div className="card-body d-flex justify-content-center p-0">
                                                    <button style={{
                                                        borderRadius: "10px",
                                                        marginTop: "5px",
                                                        fontSize: "14px",
                                                        padding: "5px 10px",
                                                        width: "100px",
                                                        marginBottom: "5px",
                                                        background: "#fff",
                                                        color: "#000",
                                                        fontWeight: "bold",
                                                        border: "0px",
                                                    }}>
                                                        All
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Dynamic Categories - Only show visible ones */}
                                            {filteredCategories.map((category) => (
                                                <div
                                                    key={category.dishId}
                                                    className="card"
                                                    onClick={() => handleClick(category.dishName)}
                                                    draggable="true"
                                                    onDragStart={(e) => handleDragStart(e, category)}
                                                    onDragOver={(e) => handleDragOver(e, category)}
                                                    onDragEnd={handleDragEnd}
                                                    onDrop={(e) => handleDrop(e, category)}
                                                    style={{
                                                        backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
                                                        marginTop: "10px",
                                                        padding: "0px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        cursor: "grab",
                                                        height: "auto",
                                                        // minHeight: "140px",
                                                        // width: "100%",
                                                        // Visual feedback for drag operations
                                                        opacity: draggedCategory && draggedCategory.dishId === category.dishId ? 0.5 : 1,
                                                        border: dragOverCategory && dragOverCategory.dishId === category.dishId ?
                                                            "2px dashed #000" : "none",
                                                        transform: dragOverCategory && dragOverCategory.dishId === category.dishId ?
                                                            "scale(1.02)" : "scale(1)",
                                                        transition: "all 0.2s ease"
                                                    }}
                                                >
                                                    {/* <img
                                                        className="card-img-top"
                                                        src={category.dishImage}
                                                        alt={category.dishName}
                                                        style={{
                                                            borderRadius: "50%",
                                                            width: "80px",
                                                            height: "80px",
                                                            display: "block",
                                                            margin: "5px auto 0",
                                                            background: "#000",
                                                            color: "#fff",
                                                            objectFit: "cover",
                                                            // Prevent image drag
                                                            userSelect: "none",
                                                            WebkitUserDrag: "none"
                                                        }}
                                                    /> */}
                                                    <div className="card-body d-flex justify-content-center p-0">
                                                        <button style={{
                                                            borderRadius: "10px",
                                                            marginTop: "8px",
                                                            fontSize: "16px",
                                                            padding: "5px 8px",
                                                            background: "#fff",
                                                            color: "#000",
                                                            width: "100px",
                                                            marginBottom: "5px",
                                                            fontWeight: "bold",
                                                            border: "0px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            cursor: "pointer"
                                                        }}>
                                                            {category.dishName}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Menu Items */}
                            <div className={`${isMobile ? 'col-12' : window.innerWidth > 1500 ? 'col-lg-10' : 'col-lg-9 col-md-9'} col-sm-12 col-12`}>
                                <Menuiteams parentId={parentId} />
                            </div>
                        </div>
                    </div>

                    {/* Cart Sidebar */}
                    <div className={`${isMobile ? 'col-12' : 'col-lg-3 col-md-4'} col-sm-12 col-12`}
                        style={{ position: "fixed", right: "10px", display: window.innerWidth <= 768 ? "none" : "block" }}>
                        <div><Orders2/></div>
                        <div style={{ marginTop: '200px' }}>

                            <MenuCartSidebar />
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`
    @media (min-width: 1000px) and (max-width: 1050px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 83%);
        }
    }

    @media (min-width: 1051px) and (max-width: 1100px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 84%);
        }
    }

    @media (min-width: 1101px) and (max-width: 1273px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 85%);
        }
    }
        
    @media (min-width: 1274px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 86%);
        }
    }
        @media(max-width:768px) {
        .anotherrow{
        margin-top:10px !important;
        }
        }
`}
            </style>
        </>
    );
};

export default Menudatas;